export default "__VITE_ASSET__DQwIb2Ou__"